// Port of api/fuel/app/classes/insights/games/universe.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function ratingBand(rating) {
	if (rating >= 9) return 0
	if (!rating || rating <= 0) return 1
	if (rating < 5) return 2
	if (rating < 7) return 3
	if (rating < 8) return 4
	return 5
}

export default Segment.extend({
	name: 'universe',
	priority: 9,
	types: [Constants.TYPE_USER],
	requires: ['init'],
	insight: ['universe.segment', 'universe.links'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var firstTouch = this._data.first_touch || {}
		var gameIndex = this._data.game_index || []
		var now = Util.time()
		var hasOwn = Object.prototype.hasOwnProperty

		if (!gameIndex.length) {
			this._data.orbits = { fresh: 0, active: 0, stale: 0 }
			return { universe: { orbits: this._data.orbits, games: [] } }
		}

		var playData = this._data.play_data || { firsts: {}, lasts: {}, counts: {} }
		var firstPlays = playData.firsts || {}
		var lastPlays = playData.lasts || {}
		var playCounts = playData.counts || {}

		var ratingData = this._data.rating_data || { lasts: {}, values: {} }
		var lastRatings = ratingData.lasts || {}
		var ratingValues = ratingData.values || {}

		var collectionData = this._data.collection_data || {}

		var freshThreshold = now - (182 * 86400)
		var staleThreshold = now - (730 * 86400)
		var games = []
		var orbits = { fresh: 0, active: 0, stale: 0 }

		for (var i = 0; i < gameIndex.length; i++) {
			var gid = parseInt(gameIndex[i], 10)
			var last = 0
			var lastType = null
			var hasLastPlay = hasOwn.call(lastPlays, gid)
			var hasLastRating = hasOwn.call(lastRatings, gid)
			var hasPlayCount = hasOwn.call(playCounts, gid)
			var hasFirstPlay = hasOwn.call(firstPlays, gid)
			var hasRatingValue = hasOwn.call(ratingValues, gid)

			if (hasLastPlay && lastPlays[gid] > last) {
				last = lastPlays[gid]
				lastType = 'played'
			}
			if (hasLastRating && lastRatings[gid] > last) {
				last = lastRatings[gid]
				lastType = 'rated'
			}
			if (collectionData[gid] && collectionData[gid].date > last) {
				last = collectionData[gid].date
				if (collectionData[gid].owned) lastType = 'owned'
				else if (collectionData[gid].prevowned) lastType = 'prevowned'
				else if (collectionData[gid].wishlisted) lastType = 'wishlisted'
				else lastType = 'collected'
			}

			var ft = firstTouch[gid] || null
			var orbit = (last >= freshThreshold) ? 'fresh' : ((last >= staleThreshold) ? 'active' : 'stale')
			orbits[orbit]++

			var hasOwned = collectionData[gid] && collectionData[gid].owned ? 1 : 0
			var hasPrevowned = collectionData[gid] && collectionData[gid].prevowned ? 1 : 0
			var hasPlayed = hasLastPlay ? 1 : 0
			var hasRated = hasLastRating ? 1 : 0
			var hasWishlisted = collectionData[gid] && collectionData[gid].wishlisted ? 1 : 0
			var ownedDate = (hasOwned && collectionData[gid]) ? collectionData[gid].date : null

			games.push({
				g: gid,
				o: orbit[0],
				p: hasPlayCount ? playCounts[gid] : 0,
				ft: ft ? String(ft.type || '').toLowerCase() : null,
				fd: ft ? ft.date : null,
				ld: last > 0 ? last : null,
				lt: lastType,
				fp: hasFirstPlay ? firstPlays[gid] : null,
				lp: hasLastPlay ? lastPlays[gid] : null,
				od: ownedDate,
				r: hasRatingValue ? ratingValues[gid] : 0,
				f: (hasOwned ? 1 : 0) | (hasPrevowned ? 2 : 0) | (hasPlayed ? 4 : 0) | (hasRated ? 8 : 0) | (hasWishlisted ? 16 : 0)
			})

			this._references.games.push(gid)
		}

		this._data.orbits = orbits

		var linkType = filter['universe.links'] || 'd'
		var links = {}
		var linkTables = {
			d: ['game_designer', 'designer_id'],
			m: ['game_mechanic', 'mechanic_id'],
			p: ['game_publisher', 'publisher_id'],
			c: ['game_category', 'category_id']
		}

		if (gameIndex.length > 1 && linkTables[linkType]) {
			var table = linkTables[linkType][0]
			var col = linkTables[linkType][1]
			var linkRows = Util.queryFast(
				'SELECT ' + col + ' AS a, GROUP_CONCAT(game_id, \',\') AS g FROM ' + table +
				' WHERE game_id IN (' + Util.in(gameIndex) + ')' +
				' GROUP BY ' + col +
				' HAVING COUNT(*) >= 2'
			)
			for (var lr = 0; lr < linkRows.length; lr++) {
				links[parseInt(linkRows[lr].a, 10)] = String(linkRows[lr].g).split(',').map(function(id) { return parseInt(id, 10) })
			}
		}

		var segmentFilter = vars.segment || false
		var universeList = []
		var universeListTotal = 0

		if (segmentFilter && typeof segmentFilter === 'object') {
			var filterOrbit = (segmentFilter.orbit !== undefined) ? segmentFilter.orbit : null
			var filterSector = (segmentFilter.sector !== undefined && segmentFilter.sector !== null) ? parseInt(segmentFilter.sector, 10) : null

			for (var gi = 0; gi < games.length; gi++) {
				var game = games[gi]
				if (filterOrbit !== null && game.o !== filterOrbit) continue
				if (filterSector !== null && ratingBand(game.r) !== filterSector) continue

				universeList.push({
					g: game.g,
					p: game.p,
					r: game.r,
					ft: game.ft,
					ld: game.ld,
					f: game.f
				})
			}

			universeList.sort(function(a, b) { return b.p - a.p })
			universeListTotal = universeList.length
			universeList = universeList.slice(0, detail ? 200 : 7)
		}

		return {
			universe: {
				orbits: orbits,
				games: games,
				links: links,
				linkType: linkType
			},
			universeList: universeList,
			universeListTotal: universeListTotal
		}
	}
})
